import { Button } from "components/Button/Button";
import { Input, Select } from "components/Form";
import useFullPageLoader from "hooks/useFullPageLoader";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  getbhaktaparivarById,
  updatebhaktaparivar,
} from "services/bhaktaparivar/bhaktaparivar";
import { getDistrictdropdownList } from "services/bhaktaparivar/bhaktaparivar";
import ReactSelect from "react-select";
import MarathiInput from "components/Form/MarathiInput";

export default function UpdateBhaktaParivar() {
  const { id } = useParams();
  const [data, setData] = useState({});
  const [errorField, setErrorField] = useState({});

  const navigate = useNavigate();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();
  const [allDistricts, setAllDistricts] = useState([]);
  const [selectedGifts, setSelectedGifts] = useState([]);


  // ************************************** Fetch Records **********************************************
  const fetchRecord = async () => {
    showLoader();
    try {
      const res = await getbhaktaparivarById({
        id: parseInt(id, 10)
        // id: id,
      });
      hideLoader();
      if (res.code === 200) {
        const {
          id,
          name,
          mobile,
          state,
          district,
          city,
          gifttype,
          email,
          age,
          address,
          pincode,
          refferalname,
        } = res.data.follower;

        // Convert comma-separated gifttype string to array
        const giftArray =
          gifttype && typeof gifttype === "string"
            ? gifttype.split(",").map((g) => g.trim())
            : [];

        // Prepare ReactSelect-compatible values
        const formattedGifts = giftArray.map((g) => ({
          value: g,
          label: g,
        }));

        setSelectedGifts(formattedGifts);
        setData({
          id,
          name,
          mobile,
          state,
          district,
          city,
          gifttype: giftArray, // store as array for internal state
          email,
          age,
          address,
          pincode,
          refferalname,
        });
      }
      else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    hideLoader();
  };
  useEffect(() => {
    fetchRecord();
  }, []);

  //*********************Handel Validation********************************** */
  const handleValidation = () => {
    let errorField = {};
    let formIsValid = true;
    if (!data.name) {
      errorField["name"] = "कृपया कुटुंब प्रमुखाचे नाव लिहा";
      formIsValid = false;
    }
    // if (!data.address) {
    //   errorField["address"] = "कृपया पत्ता लिहा";
    //   formIsValid = false;
    // }
    if (!data.gifttype) {
      errorField["gifttype"] = "कृपया आहेर निवडा";
      formIsValid = false;
    }
    if (!data.mobile) {
      errorField["mobile"] = "कृपया आपला फोन नंबर लिहा";
      formIsValid = false;
    } else if (data.mobile.length !== 10) {
      errorField["mobiles"] = "मोबाईल नंबर 10 अंकी असणे आवश्यक आहे";
      formIsValid = false;
    }
    if (!data.district) {
      errorField["district"] = "कृपया जिल्हा निवडा";
      formIsValid = false;
    }
    if (!data.city) {
      errorField["city"] = "कृपया शहर लिहा";
      formIsValid = false;
    }
    if (!data.state) {
      errorField["state"] = "कृपया राज्य निवडा";
      formIsValid = false;
    }
    // if (!data.pincode) {
    //   errorField["pincode"] = "कृपया पिनकोड लिहा";
    //   formIsValid = false;
    // } else if (data.pincode.length !== 4) {
    //   errorField["pincodes"] = "पिनकोड क्रमांक ४ अंकी असणे आवश्यक आहे";
    //   formIsValid = false;
    // }

    setErrorField(errorField);
    return formIsValid;
  };
  // ****************************** Fetch All Districts *****************************************
  const fetchAllDistricts = async () => {
    showLoader();
    try {
      const res = await getDistrictdropdownList({ stateId: data.state });
      hideLoader();
      if (res.code === 200) {
        setAllDistricts(res.data?.districts?.rows?.rows);
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    hideLoader();
  };
  useEffect(() => {
    if (data && data.state) {
      fetchAllDistricts();
    }
  }, [data.state]);
  //*********************Submit Sankalpana Handler********************************** *//
  const submitSankalpana = async (e) => {
    e.preventDefault();
    if (handleValidation()) {
      setSubmitLoading(true);
      try {
        const gifttypeString = Array.isArray(data.gifttype)
          ? data.gifttype.join(", ")
          : data.gifttype || "";


        const res = await updatebhaktaparivar({
          id: id,
          name: data.name,
          mobile: data.mobile,
          state: data.state,
          district: data.district,
          city: data.city,
          email: data.email,
          age: data.age,
          address: data.address,
          pincode: data.pincode,
          gifttype: gifttypeString,
          refferalname: data.refferalname,
        });
        if (res.code === 200) {
          toast.success(res.message);
          setSubmitLoading(false);
          navigate(-1);
        } else {
          toast.error(res.message);
          setSubmitLoading(false);
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || err.message);
        setSubmitLoading(false);
      }
    } else {
      toast.error("सर्व माहिती भरण आवश्यक आहे");
    }
  };
  return (
    <>
      <div className="">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="search_wrap">
              <div className="search_wrap"></div>
              <h4 className="Title">
                <Link to={-1}>
                  <i className="fa fa-arrow-left"></i>
                </Link>
                भक्त परिवार माहिती अपडेट करा
              </h4>
            </div>

            <div className="row mt-1">
              <div className="col-12 col-sm-12 col-md-12 col-lg-11 col-xl-11 mx-auto">
                <form onSubmit={submitSankalpana}>
                  <div className="form-group row mt-1">
                    <div className="col-md-12 col-form-label order-1 d-flex flex-column justify-content-end">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="row"><div className="col-sm-6 col-form-label">

                            <MarathiInput
                              name="refferalname"
                              value={data.refferalname}
                              onChange={(e) => {
                                const { name, value } = e.target;
                                setData({ ...data, [name]: value });
                              }}
                              placeholder="कुटुंब प्रमुखाचे नाव/ संदर्भित व्यक्ती लिहा"
                              label="कुटुंब प्रमुखाचे नाव/ संदर्भित व्यक्ती"
                              maxLength={50}
                              error={errorField.refferalname}
                              required
                            />

                          </div>

                            <div className="col-sm-6 col-form-label">

                              <MarathiInput
                                name="name"
                                value={data.name}
                                onChange={(e) => {
                                  const { name, value } = e.target;
                                  setData({ ...data, [name]: value });
                                }}
                                placeholder="नाव लिहा"
                                label="नाव"
                                maxLength={50}
                                error={errorField.name}
                                required
                              />
                            </div>
                            <div className="col-sm-6 col-form-label">
                              <Input
                                type="text"
                                name="mobile"
                                value={data.mobile}
                                onChange={(e) => {
                                  const { value, name } = e.target;
                                  setData({
                                    ...data,
                                    [name]: value.replace(/\D/g, ""),
                                  });
                                }}
                                placeholder="फोन नंबर लिहा"
                                className={`form-control `}
                                maxLength={10}
                                label="फोन नंबर"
                                error={errorField.mobile}
                                required
                              />
                              {errorField.mobiles && (
                                <span
                                  className="error"
                                  style={{
                                    color: "#dc3545",
                                    fontSize: "13px",
                                    marginLeft: "1px",
                                  }}
                                >
                                  {errorField.mobiles}
                                </span>
                              )}
                            </div>
                            <div className="col-sm-6 col-form-label">
                              <Input
                                type="text"
                                name="email"
                                value={data.email}
                                onChange={(e) => {
                                  const { value, name } = e.target;
                                  setData({
                                    ...data,
                                    [name]: value,
                                  });
                                }}
                                placeholder="ईमेल लिहा"
                                className={`form-control `}
                                maxLength={50}
                                label="ईमेल"
                                error={errorField.email}
                                required
                              />
                            </div>
                            <div className="col-sm-6 col-form-label">
                              <MarathiInput
                                name="address"
                                value={data.address}
                                onChange={(e) => {
                                  const { name, value } = e.target;
                                  setData({ ...data, [name]: value });
                                }}
                                placeholder="पत्ता लिहा"
                                label="पत्ता"
                                maxLength={50}
                                error={errorField.address}
                                required
                              />
                            </div>
                            <div className="col-sm-6  col-form-label">
                              <Select
                                name={`state`}
                                placeholder={`राज्य निवडा`}
                                onChange={(e) => {
                                  const { name, value } = e.target;
                                  setData({ ...data, [name]: value });
                                }}
                                value={data.state}
                                className={`form-control `}
                                label={`राज्य`}
                                error={errorField.state}
                                required
                              >
                                <option value="">राज्य निवडा</option>
                                {["महाराष्ट्र", "इतर"].map((data) => {
                                  return (
                                    <option value={data} key={data}>
                                      {data}
                                    </option>
                                  );
                                })}
                              </Select>
                            </div>
                            <div className="col-sm-6 col-form-label">
                              <Select
                                name="district"
                                placeholder="जिल्हा निवडा"
                                onChange={(e) => {
                                  const { name, value } = e.target;
                                  setData({ ...data, [name]: value });
                                }}
                                value={data.district}
                                className={`form-control `}
                                onClick={() => {
                                  if (!data.state) {
                                    toast.error("कृपया राज्य निवडा");
                                  }
                                }}
                                label={"जिल्हा"}
                                error={errorField.district}
                                required
                              >
                                <option value="">जिल्हा निवडा</option>
                                {allDistricts &&
                                  allDistricts.map(({ id, districtname }) => (
                                    <option value={id} key={id}>
                                      {districtname}
                                    </option>
                                  ))}
                              </Select>
                            </div>
                            <div className="col-sm-6 col-form-label">
                              <MarathiInput
                                name="city"
                                value={data.city}
                                onChange={(e) => {
                                  const { name, value } = e.target;
                                  setData({ ...data, [name]: value });
                                }}
                                placeholder="शहर लिहा"
                                label="शहर"
                                maxLength={50}
                                error={errorField.city}
                                required
                              />
                            </div>
                            <div className="col-sm-6 col-form-label">
                              <Input
                                type="text"
                                name="pincode"
                                value={data.pincode}
                                onChange={(e) => {
                                  const { value, name } = e.target;
                                  setData({
                                    ...data,
                                    [name]: value.replace(/\D/g, ""),
                                  });
                                }}
                                placeholder="पिनकोड लिहा"
                                className={`form-control `}
                                maxLength={6}
                                label="पिनकोड"
                                error={errorField.pincode}
                                required
                              />
                              {errorField.pincodes && (
                                <span
                                  className="error"
                                  style={{
                                    color: "#dc3545",
                                    fontSize: "13px",
                                    marginLeft: "1px",
                                  }}
                                >
                                  {errorField.pincodes}
                                </span>
                              )}
                            </div>
                            <div className="col-sm-6 col-form-label">
                              <Input
                                type="text"
                                name="age"
                                value={data.age}
                                onChange={(e) => {
                                  const { value, name } = e.target;
                                  setData({
                                    ...data,
                                    [name]: value,
                                  });
                                }}
                                placeholder="वय लिहा"
                                className={`form-control `}
                                maxLength={50}
                                label="वय"
                                error={errorField.age}
                                required
                              />
                            </div>
                            <div className="col-sm-6 col-form-label">
                              <label className="form-label">
                                आहेर <span style={{ color: "red" }}>*</span>
                              </label>
                              <ReactSelect
                                isMulti
                                name="gifttype"
                                placeholder="आहेर निवडा"
                                value={selectedGifts}
                                onChange={(selected) => {
                                  setSelectedGifts(selected);
                                  setData({
                                    ...data,
                                    gifttype: selected ? selected.map((s) => s.value) : [],
                                  });
                                }}
                                options={[
                                  { value: "साडी", label: "साडी" },
                                  { value: "धोतर", label: "धोतर" },
                                  { value: "शर्ट पँट", label: "शर्ट पँट" },
                                  { value: "माहित नाही", label: "माहित नाही" },
                                ]}
                                classNamePrefix="select"
                              />
                              {errorField.gifttype && (
                                <span className="text-danger" style={{ fontSize: "13px" }}>
                                  {errorField.gifttype}
                                </span>
                              )}
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="text-center mt-4">
                    <Button
                      to={-1}
                      // {...submitButtonElement}
                      style={{ marginRight: "5px" }}
                    >
                      रद्द करा
                    </Button>
                    <Button
                      type="submit"
                    // {...submitButtonElement}
                    >
                      अपडेट करा
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
